import {
  SET_TIKTOKSHOP_UI_FLAG,
  GET_COUPONS,
  GET_ORDERS,
  SEARCH_PRODUCTS,
  SEND_ORDER_MESSAGE,
  SEND_PRODUCT_MESSAGE,
} from './types';
import TiktokShopAPI from '../../../api/inbox/tiktokShop';

export const actions = {
  getCoupons: async ({ commit }, { conversationID }) => {
    commit(SET_TIKTOKSHOP_UI_FLAG, { isFetchingCoupons: true });
    try {
      const response = await TiktokShopAPI.getCoupons(conversationID);
      commit(GET_COUPONS, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TIKTOKSHOP_UI_FLAG, { isFetchingCoupons: false });
    }
  },
  getOrders: async ({ commit }, { conversationID, orderStatus }) => {
    commit(SET_TIKTOKSHOP_UI_FLAG, { isFetchingOrders: true });
    try {
      const response = await TiktokShopAPI.getOrders({
        conversationID,
        orderStatus,
      });
      commit(GET_ORDERS, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TIKTOKSHOP_UI_FLAG, { isFetchingOrders: false });
    }
  },
  searchProducts: async ({ commit }, { conversationID, searchQuery }) => {
    commit(SET_TIKTOKSHOP_UI_FLAG, { isSearchingProducts: true });
    try {
      const response = await TiktokShopAPI.searchProducts(
        conversationID,
        searchQuery
      );
      commit(SEARCH_PRODUCTS, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TIKTOKSHOP_UI_FLAG, { isSearchingProducts: false });
    }
  },
  sendOrderMessage: async ({ commit }, { conversationID, orderID }) => {
    try {
      const response = await TiktokShopAPI.sendOrder(conversationID, orderID);
      commit(SEND_ORDER_MESSAGE, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  sendProductMessage: async ({ commit }, { conversationID, productID }) => {
    try {
      const response = await TiktokShopAPI.sendProduct(
        conversationID,
        productID
      );
      commit(SEND_PRODUCT_MESSAGE, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },
};
